import type { EndpointDefinition } from "../../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    updateBillingDetails: {
        route: "/workspaces/:workspaceId/billing/customers/billing-details",
        method: "POST"
    },
    calculateTaxAmount: {
        route: "/workspaces/:stripeProductId/billing/calculated-taxes",
        method: "POST"
    }
};
